import { useMemo } from "react";

import { ProcessStepCatalogDto } from "#modules/quoteRequestLines/infra/fetchProcessStepCatalog.api";
import { useProcessStepCatalog } from "#modules/quoteRequestLines/view/useProcessStepCatalog";
import { isSurfaceTreatmentProcessStep } from "shared";

export const useSurfaceTreatments = (): {
  surfaceTreatments: ProcessStepCatalogDto;
} => {
  const { processStepCatalog } = useProcessStepCatalog();

  const surfaceTreatments = useMemo(
    () => processStepCatalog.filter(isSurfaceTreatmentProcessStep),
    [processStepCatalog],
  );

  return { surfaceTreatments };
};
